import { render } from "./PayAudioPlaylistShell.vue?vue&type=template&id=44b195ba&scoped=true"
import script from "./PayAudioPlaylistShell.vue?vue&type=script&lang=js"
export * from "./PayAudioPlaylistShell.vue?vue&type=script&lang=js"

import "./PayAudioPlaylistShell.vue?vue&type=style&index=0&id=44b195ba&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b195ba"]])

export default __exports__